import WhoToCover from './WhoToCover'

export default WhoToCover
